module.exports = __webpack_public_path__ + "images/landing-woman.webp";